import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { BaseRequest, BaseResponse } from '../models'
import { OnboardingFlow, OnboardingFlowType, OnboardingStepStatus } from '../../models/Onboarding'

const _BASE_URL = import.meta.env.REACT_APP_GROWTH_SUPPORT_API_BASE_URL!

export interface OnboardingFlowRequest extends BaseRequest {
  flowType: OnboardingFlowType
}

export const onboardingApi = createApi({
  reducerPath: 'onboardingApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  tagTypes: ['Onboarding'],
  endpoints: (builder) => ({
    getOnboardingFlow: builder.query<BaseResponse<OnboardingFlow>, OnboardingFlowRequest>({
      query: (request) => `/accounts/${request.accountId}/onboarding/${request.flowType}`,
      providesTags: ['Onboarding'],
    }),
    completeOnboardingFlow: builder.mutation<BaseResponse<OnboardingFlow>, OnboardingFlowRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/onboarding/${request.flowType}/complete`,
        method: 'POST',
      }),
      invalidatesTags: ['Onboarding'],
    }),
    dismissOnboardingFlow: builder.mutation<BaseResponse<OnboardingFlow>, OnboardingFlowRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/onboarding/${request.flowType}/dismiss`,
        method: 'POST',
      }),
      invalidatesTags: ['Onboarding'],
    }),
    completeOnboardingStep: builder.mutation<BaseResponse<OnboardingFlow>, OnboardingFlowRequest & { stepId: string }>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/onboarding/${request.flowType}/steps/${request.stepId}/complete`,
        method: 'POST',
      }),
      invalidatesTags: ['Onboarding'],
    }),
    dismissOnboardingStep: builder.mutation<BaseResponse<OnboardingFlow>, OnboardingFlowRequest & { stepId: string; status?: OnboardingStepStatus }>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/onboarding/${request.flowType}/steps/${request.stepId}/dismiss`,
        method: 'POST',
        body: request.status !== undefined ? { status: request.status } : undefined,
      }),
      invalidatesTags: ['Onboarding'],
    }),
  }),
})

export const {
  useGetOnboardingFlowQuery,
  useCompleteOnboardingFlowMutation,
  useDismissOnboardingFlowMutation,
  useCompleteOnboardingStepMutation,
  useDismissOnboardingStepMutation,
} = onboardingApi
